export const TIMEOUT = 10000;
export const baseRoute = '/storage/'
const devBaseURL = "http://192.168.2.69:32301";
//const devBaseURL = 'http://192.168.6.164:8080';
const proBaseURL = baseRoute + "api";



export const baseURL = process.env.NODE_ENV === 'development' ? devBaseURL: proBaseURL;